export const safeParseInt = (str: string): number | undefined => (isNaN(Number(str)) ? undefined : Number(str));
